import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpService } from './http.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(
    private http: HttpService,
    public dialog: MatDialog,
  ) { }


   private sspToken: string | null = null;

  setToken(token: string): void {
    this.sspToken = token;
   
  }

  getToken(): string | null {
    
    if(this.sspToken){
      return this.sspToken;
    }
    else{
      return this.sspToken = sessionStorage.getItem('setToken')
    }
  }

  clearToken(): void {
    this.sspToken = null;
    
  }
}
